import { NavItem, NAVIGATION_DATA } from './navigation-data';
import { Type } from '@angular/core';
import { DashboardComponent } from '../../components/dashboard/dashboard.component';


export const COMPONENT_MAP: { [key: string]: Type<any> } = {};
COMPONENT_MAP['dashboard'] = DashboardComponent
// Recursive function to flatten nested navigation
function extractComponents(items: NavItem[]) {
  console.log(NAVIGATION_DATA);
  for (const item of items) {
    if (item.component && item.componentKey) {
      COMPONENT_MAP[item.componentKey.trim().toLowerCase()] = item.component;
    }
    if (item.children) {
      extractComponents(item.children);
    }
  }
}

// Build the map once when this file is imported
extractComponents(NAVIGATION_DATA);

// Keep previously saved outbound tabs opening the combined queue.
COMPONENT_MAP['outboundmanagement'] = COMPONENT_MAP['ordermanagement'];
